export default __webpack_public_path__ + "static/media/highlight-3-new.7b8373a6.jpg";